import { render, staticRenderFns } from "./assessment-subpage.vue?vue&type=template&id=778c2674&lang=pug&"
import script from "./assessment-subpage.vue?vue&type=script&lang=js&"
export * from "./assessment-subpage.vue?vue&type=script&lang=js&"
import style0 from "./assessment-subpage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports